const slick = require('slick-carousel'); //TODO Use Glide instead of slick https://glidejs.com/
const magnificPopup = require('magnific-popup');

$('.image-slider').each(function () {
    var $this = $(this);
    if ($this.children().length > 1) {
        $this.slick({
            infinite: true
            , rows: 0
        });
    }
});


$('.section--two-column').magnificPopup({
    delegate: '.tc--image-slider-col a.image-modal:not(.slick-cloned), .tc--img-col a.image-modal',
    type: 'image',
    closeOnContentClick: false,
    closeBtnInside: false,
    mainClass: 'mfp-with-zoom mfp-img-mobile',
    image: {
        verticalFit: true,
    },
    gallery: {
        enabled: true
    },
    zoom: {
        enabled: true,
        duration: 300,
        opener: function (element) {
            return element.find('img');
        }
    }
});
